import { useState } from 'react';
import PropTypes from 'prop-types';
import { RemoveCertificatePrompt } from 'components/Cart/Prompts/RemoveCertificatePrompt';
import { Link } from 'components/UI/Link/Link';
import { toAudString } from 'utils/currency';

export const PurchasedGiftCertificatesSummary = (props) => {
  const { purchasedGiftCertificates, allowRemove, stepName, redeemedGiftCertificates } = props;
  const [removeCertificate, setRemoveCertificate] = useState(null);
  const showPrompt = (item) => {
    setRemoveCertificate(item);
  };

  return (
    <>
      <RemoveCertificatePrompt
        active={!!removeCertificate}
        giftCertificate={removeCertificate}
        stepName={stepName}
        onRequestClose={() => {
          setRemoveCertificate(null);
        }}
        totalLineItem={purchasedGiftCertificates.length}
        forceBackToCurrentPage={false}
      />

      <hr />
      <span className="info-label">Gift Vouchers</span>
      {purchasedGiftCertificates.map((giftCertificate, index) => {
        const { Description, Amount, ObfuscatedNumber } = giftCertificate;

        let descriptionDisplay;
        if (Description === 'Chicago Gift Voucher') {
          descriptionDisplay = `Chicago - ${ObfuscatedNumber}`;
        } else if (Description === 'Evita Gift Voucher') {
          descriptionDisplay = `Evita - ${ObfuscatedNumber}`;
        } else {
          descriptionDisplay = ObfuscatedNumber;
        }

        return (
          <div className="row" key={index} data-testid="purchased-gift-voucher">
            <div className="col-xs-8">
              <span>{descriptionDisplay}</span>
            </div>
            <div className="col-xs-4 text-right">{toAudString(Amount)}</div>

            {redeemedGiftCertificates.length > 0 && allowRemove ? (
              <Link
                href="#"
                noUnderline
                onClick={() => {
                  showPrompt(giftCertificate);
                }}
                variant="secondary"
                extendClass="link-bold link-remove ml-10"
              >
                Remove Certificate
              </Link>
            ) : null}
          </div>
        );
      })}
    </>
  );
};

PurchasedGiftCertificatesSummary.propTypes = {
  purchasedGiftCertificates: PropTypes.array,
  allowRemove: PropTypes.bool,
  stepName: PropTypes.string,
  redeemedGiftCertificates: PropTypes.array,
};
